import React from "react";

const AboutJRIIT = () => {
  return (
    <section id="about" className="relative py-32 bg-custom-pink overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-gold opacity-10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-80 h-80 bg-white opacity-5 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gold opacity-5 rounded-full blur-2xl animate-pulse delay-500"></div>
      </div>

      {/* Decorative geometric shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-16 right-1/4 w-6 h-6 bg-gold opacity-30 transform rotate-45"></div>
        <div className="absolute top-1/3 left-1/4 w-4 h-4 bg-white opacity-20 rounded-full"></div>
        <div className="absolute bottom-1/3 right-1/3 w-8 h-8 bg-gold opacity-20 transform rotate-12"></div>
        <div className="absolute bottom-16 left-1/3 w-5 h-5 bg-white opacity-15 transform rotate-45"></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-6">
        {/* Title with enhanced styling */}
        <div className="text-center mb-12">
          <div className="inline-block">
            <h2 className="text-5xl lg:text-6xl font-bold text-gold mb-4 relative">
              About JR Institute
              {/* Decorative underline */}
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gold rounded-full"></div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-white opacity-50 rounded-full"></div>
            </h2>
          </div>
        </div>

        {/* Content container with enhanced design */}
        <div className="relative">
          {/* Main content card */}
          <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-3xl p-12 border border-white border-opacity-20 shadow-2xl">
            {/* Decorative corner elements */}
            <div className="absolute top-8 left-8 w-16 h-16 border-l-2 border-t-2 border-gold opacity-50 rounded-tl-lg"></div>
            <div className="absolute bottom-8 right-8 w-16 h-16 border-r-2 border-b-2 border-gold opacity-50 rounded-br-lg"></div>

            <div className="relative z-10">
              <p className="text-xl lg:text-2xl leading-relaxed text-white text-center font-light tracking-wide">
                JR Institute is dedicated to shaping future leaders by providing
                high-quality education, innovative learning experiences, and a
                supportive community. Our programs are designed to equip
                students with the knowledge, practical skills, and confidence
                they need to excel in their careers and personal lives. We value
                diversity, creativity, and excellence, ensuring that every
                student feels empowered to achieve their full potential in a
                world of endless opportunities.
              </p>
            </div>

            {/* Subtle inner glow */}
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-transparent via-white to-transparent opacity-5"></div>
          </div>

          {/* Floating accent elements */}
          <div className="absolute -top-6 -left-6 w-12 h-12 bg-gold rounded-full opacity-30 animate-bounce delay-300"></div>
          <div className="absolute -bottom-6 -right-6 w-8 h-8 bg-white rounded-full opacity-20 animate-bounce delay-700"></div>
        </div>
      </div>

      {/* Bottom wave decoration */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          viewBox="0 0 1200 120"
          className="w-full h-12 text-gold opacity-20"
        >
          <path
            d="M0,50 C300,10 600,90 900,50 C1050,25 1150,50 1200,40 L1200,120 L0,120 Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </section>
  );
};

export default AboutJRIIT;
